export default "/images/vendor/flag-icons/flags/4x3/sl.svg?d4cd148ff94760097b5c009e01b98e48";